import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c967041"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "font-bold text-2xl" }

import { reactive } from 'vue';
import { PageWithChildrenDto } from 'stores/modules/page';
import SvProjectTabs from './SvProjectTabs.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SvProductTabs',
  props: {
    pages: {}
  },
  setup(__props: any) {



const state = reactive({
  tab: 0,
});

return (_ctx: any,_cache: any) => {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_card, { class: "mb-8 p-4 bg-transparent" }, {
      default: _withCtx(() => [
        _createVNode(_component_q_tabs, {
          modelValue: state.tab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.tab) = $event)),
          class: "flex justify-center",
          "content-class": "flex justify-between",
          "active-class": "text-green-600",
          "indicator-color": "transparent"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: page.id
              }, [
                (page.children?.length)
                  ? (_openBlock(), _createBlock(_component_q_tab, {
                      key: 0,
                      class: "flex justify-start",
                      name: i,
                      ripple: false,
                      "no-caps": ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(page.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["name"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_q_tab_panels, {
      class: "bg-transparent",
      style: {"height":"32rem"},
      modelValue: state.tab,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.tab) = $event)),
      animated: "",
      swipeable: "",
      vertical: "",
      "transition-prev": "jump-up",
      "transition-next": "jump-up"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: page.id
          }, [
            (page.children?.length)
              ? (_openBlock(), _createBlock(_component_q_tab_panel, {
                  key: 0,
                  class: "p-1",
                  name: i
                }, {
                  default: _withCtx(() => [
                    _createVNode(SvProjectTabs, {
                      pages: page.children
                    }, null, 8, ["pages"])
                  ]),
                  _: 2
                }, 1032, ["name"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})